import { Button } from '@material-tailwind/react';
import PhoneImg from '../assets/img/phone.png'

export default function DownloadWallet() {
    return (
        <div className='relative w-full px-4 sm:px-[20px] lg:px-[80px] 2xl:px-[235px] mt-16 sm:mt-24 lg:mt-[180px] pb-16 sm:pb-[80px]'>
            <div className='flex flex-col lg:flex-row justify-between items-center w-full min-h-[280px] lg:h-[415px] rounded-[23px] bg-[#1B1B1B] overflow-hidden'>
                <div className='flex lg:basis-2/5 justify-center w-full pt-8 lg:pt-0'>
                    <img src={PhoneImg} className='relative w-[180px] sm:w-[240px] lg:w-auto lg:absolute lg:bottom-[40px] max-w-[280px]' alt='Flash Wallet app' />
                </div>
                <div className='flex flex-col items-center lg:items-start py-8 lg:py-0 lg:basis-3/5 px-4'>
                    <p className='text-[#fff] font-Inter-Regular text-[24px] sm:text-[42px] text-center lg:text-left'>
                        Download Flash Wallet
                    </p>
                    <p className='text-[#86888C] font-Inter-Regular text-[15px] sm:text-[16px] text-center lg:text-left w-full max-w-[450px] mt-[20px]'>
                        1st Dapps in the decentralized world to easily transfer your funds to your heirs.
                    </p>
                    <div className='flex flex-row flex-wrap justify-center gap-3 mt-[28px]'>
                        <Button className="bg-[url('./assets/img/google.svg')] bg-cover w-[155px] h-[45px]">{` `}</Button>
                        <Button className="bg-[url('./assets/img/appstore.svg')] bg-cover w-[155px] h-[45px]">{' '}</Button>
                    </div>
                </div>
            </div>
        </div>
    )
}
